var styles = {
  "Shimmer": "_Shimmer_hqp2w_1",
  "shimmer": "_shimmer_hqp2w_1"
};

export { styles as default };
